var NewsController = function() {
    this.SingleImgAdjust = require('../module/SingleImgAdjust');
    this.init();
};

NewsController.prototype = {
    init: function() {
        var singleImgAdjust = new this.SingleImgAdjust();
        singleImgAdjust.init();

    }
};

module.exports = NewsController;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/controller/NewsController.js
 **/